// Derived lifecycle state of a service contract. A "current" contract is one of
// Requested, Active or Locked; Canceled and Expired are terminal.
export type ContractStatus = 'Requested' | 'Active' | 'Locked' | 'Canceled' | 'Expired';

// Lifecycle transitions an admin can apply via PATCH /service-contracts/{id}.
export type ContractAction = 'activate' | 'lock' | 'unlock' | 'cancel';

// Request contact data captured when a company requests a contract.
export interface ServiceContractMetadata {
  name?: string;
  phoneNumber?: string;
  email?: string;
}

// A full service contract as returned by GET /v1/devices/{deviceId}/service-contracts.
export interface ServiceContract {
  id: string;
  deviceId: string;
  companyId: string;
  status: ContractStatus;
  signedOn: string | null;
  expiresOn: string | null;
  canceledOn: string | null;
  duration: number;
  isLocked: boolean;
  metadata?: ServiceContractMetadata | null;
  createdAt?: string;
}

// A document attached to a service contract.
export interface ServiceContractDocument {
  id: string;
  name: string;
  dataAvailable: boolean;
  createdAt?: string;
}

export interface CreateServiceContractRequest {
  deviceId: string;
  companyId: string;
  duration: number;
  signedAt: string;
}

export interface PatchServiceContractRequest {
  action: ContractAction;
  duration?: number;
  signedAt?: string;
}

// Selectable contract durations in months.
export const CONTRACT_DURATIONS = [48, 60] as const;

// A contract is "current" (blocks new contracts) when Requested, Active or Locked.
export function isCurrentContract(contract: ServiceContract): boolean {
  return (
    contract.status === 'Requested' ||
    contract.status === 'Active' ||
    contract.status === 'Locked'
  );
}
